module.exports = __webpack_public_path__ + "img/blue-h.812fb890.svg";